/**
 * Generated from ch4_p06.fla
 */
export function ch4_p06(this: Ich4_p06) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch4_p06_hh_ch4_p0607psdAssetchp4_p06_holly1.call(holly[0] as Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_holly1);
		holly[0].x = 967;
		holly[0].y = 384;
		holly[0].width = 682.00;
		holly[0].height = 768.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch4_p06_hh_ch4_p0607psdAssetchp4_p06_holly2.call(holly[1] as Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_holly2);
		holly[1].x = 967;
		holly[1].y = 384;
		holly[1].width = 682.00;
		holly[1].height = 768.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const bg = this.bg;
	ch4_p06_hh_ch4_p0607psdAssetchp4_p06_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const frameRight = this.frameRight;
	ch4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeR.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeL.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch4_p06_hh_ch4_p0607psdAssetchp4_p06_bg(this: Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p06_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p06_hh_ch4_p0607psdAssetchp4_p06_holly1(this: Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_holly1) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p06_holly1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p06_hh_ch4_p0607psdAssetchp4_p06_holly2(this: Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_holly2) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p06_holly2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeR(this: Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeL(this: Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich4_p06Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich4_p06Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich4_p06Sprite extends Ich4_p06Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich4_p06Text extends Ich4_p06Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich4_p06Polygon extends Array<number> {
}
interface Ich4_p06 {
	readonly holly: Ich4_p06Array<Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_holly1|Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_holly2>;
	readonly bg: Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_bg;
	readonly frameRight: Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeR;
	readonly frameLeft: Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeL;
}
interface Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_bg extends Ich4_p06Sprite {
}
interface Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_holly1 extends Ich4_p06Sprite {
}
interface Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_holly2 extends Ich4_p06Sprite {
}
interface Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeR extends Ich4_p06Sprite {
}
interface Ich4_p06_hh_ch4_p0607psdAssetchp4_p06_wcframeL extends Ich4_p06Sprite {
}
